import { render, staticRenderFns } from "./billingCorporateDetailBillingType.vue?vue&type=template&id=347bb888&scoped=true"
import script from "./billingCorporateDetailBillingType.vue?vue&type=script&lang=js"
export * from "./billingCorporateDetailBillingType.vue?vue&type=script&lang=js"
import style0 from "./billingCorporateDetailBillingType.vue?vue&type=style&index=0&id=347bb888&prod&lang=css"
import style1 from "./billingCorporateDetailBillingType.vue?vue&type=style&index=1&id=347bb888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347bb888",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VDataTable})
